import { AppState } from "features";

export const getLocationSettings = ({ LocationSettings: { edit } }: AppState) =>
    edit.status === "loaded" ? edit.data : undefined;
